import React from 'react';

export const SectionItem = ({label, value}) => {
    return (
        <>
            <span className="gray-300 text-nowrap">{label}</span>
            <span className="mb-2">
              <p className="font-weight-bold mb-0">{value}</p>
          </span>
        </>
    );
};
